// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1298":"719face9","2947":"c3a71a48","5986":"719face9"}[chunkId] + ".chunk.css";
};